import { render, staticRenderFns } from "./RightSideBtn.vue?vue&type=template&id=05c576b0&scoped=true&"
import script from "./RightSideBtn.vue?vue&type=script&lang=js&"
export * from "./RightSideBtn.vue?vue&type=script&lang=js&"
import style0 from "./RightSideBtn.vue?vue&type=style&index=0&id=05c576b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c576b0",
  null
  
)

export default component.exports